import React, { useContext } from 'react'
import Layout from '../../../shared/components/organisms/layout/layout'
import Seo from '../../../shared/seo'
import useMediaQuery from '../../../utils/useMediaQuery'
import NavMenu from '../../../components/molecules/nav-menu/nav-menu'
import ModalViewer from '../../organisms/modal-viewer/modal-viewer'
import { title, description } from './../../../constants/activity-seo'
import { Context } from '../../../context/app-context'

import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'

import './page-layout.scss'

const PageLayout = ({ hiddenNav, children, mt46 }) => {
  const isMobile = useMediaQuery()
  const { dispatch } = useContext(Context)

  const userInfo = getUserInfo()

  return (
    <Layout mobile={isMobile}>
      <Seo title={title} description={description} />
      <ModalViewer />
      <div className="f-page-layout__container">
        {!hiddenNav && <NavMenu isMobile={isMobile} />}
        <div className={isMobile ? '' : mt46 ? 'f-mt46' : ''}>{children}</div>
      </div>
      <div className="f-containerTerminos">
        <p>
          Conoce los{' '}
          <a
            className="f-containerTerminos__aTerminos"
            onClick={async () => {
              pushEventData({
                event: 'Interacciones_Home_UCole',
                label: 'terminos y condiciones',
                user_data: userInfo && [
                  await jsonToHash({
                    nombre: userInfo.name,
                    apellido: userInfo.lastName,
                    celular: userInfo.cellPhone,
                    correo: userInfo.email,
                    ciudad: userInfo.location.cityName,
                    departamento: userInfo.location.countryStateName,
                    pais: userInfo.countryName,
                  }),
                ],
                log_status: userInfo ? 'Yes' : 'Not',
              })
              dispatch({
                type: 'set-modal',
                modalActive: {
                  type: 'terms',
                  wrapperProps: {
                    className: 'f-modalTerms',
                  },
                },
              })
            }}
          >
            terminos y condiciones
          </a>
        </p>
      </div>
    </Layout>
  )
}

export default PageLayout
